import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.dark.scss';
import './themes/generated/theme.base.scss';
import './themes/generated/theme.additional.dark.scss';
import './themes/generated/theme.additional.scss';
import React, { useEffect } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import { ThemeContext, useThemeContext} from "./theme";

import { useState } from 'react';
// import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { callSecureApi } from './services/authService';

function App() {
  const { user, loading } = useAuth();
  // const { instance } = useMsal();
  // const isAuthenticated = useIsAuthenticated();
  const [apiData, setApiData] = useState(null);
  const [error, setError] = useState<string | null>(null);

  // const fetchData = async () => {
  //   if (isAuthenticated) {
  //     try {
  //       const data = await callSecureApi(instance, 'securedata');
  //       setApiData(data);
  //       setError(null);
  //     } catch (err) {
  //       setError(`Error fetching data: ${(err as Error).message}`);
  //       setApiData(null);
  //     }
  //   }
  // };
  
  // useEffect(() => {
  //   fetchData();
  // }, [isAuthenticated]);

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();
  const themeContext = useThemeContext();
  // const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    
    const closeBanner = () => {
        const banner = document.querySelector('dx-license');
        if (banner) {
            const closeButton = banner.querySelector('div:has(svg)');
            if (closeButton) {
                (closeButton as HTMLElement).click();
            }
        }
    };
    
    // Initial check
    closeBanner();
    
    // Use MutationObserver for dynamic changes
    const observer = new MutationObserver((mutations) => {
        // Clear existing timeout
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        
        // Set a debounced timeout
        timeoutId = setTimeout(closeBanner, 100);
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    return () => {
        observer.disconnect();
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
    };
    }, []);

  return (
    <Router>
      <ThemeContext.Provider value={themeContext}>
        <AuthProvider>
          <NavigationProvider>
            <div className={`app ${screenSizeClass}`}>
              <App />
            </div>
          </NavigationProvider>
        </AuthProvider>
      </ThemeContext.Provider>
    </Router>
  );
}

